<form class="form" [formGroup]="service.filters" (submit)="onSubmit()" [class.submitted]="submitted">
    <!-- Metrics selection -->
    <mat-form-field aria-label="Metrics selection">
        <mat-label>Select metrics to show</mat-label>
        <mat-chip-grid #chipGrid aria-label="Metrics selection">
            @for (chip of this.service.metricsSelected; track chip) {
                <mat-chip-row (removed)="removed(chip)">
                    {{chip.label}}
                    <button matChipRemove [attr.aria-label]="'remove ' + chip">
                      <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            }
        </mat-chip-grid>
        
        <input #chipInput type="text" placeholder="Add metric" matInput [formControl]="this.service.metricsForm"
            [matAutocomplete]="autoMetric" [matChipInputFor]="chipGrid" (input)="filter()" (focus)="filter()" (matChipInputTokenEnd)="add($event)">
        <mat-autocomplete requireSelection #autoMetric="matAutocomplete" (optionSelected)="selected($event)">
          @for (metric of metricsFiltered; track metric) {
            <mat-option [value]="metric">{{metric.label}}</mat-option>
          }
        </mat-autocomplete>
    </mat-form-field>
    
    <!-- Season filter -->
    <mat-form-field>
        <mat-label>Filter by season</mat-label>
        <mat-select formControlName="season">
            @for (season of seasons; track season) {
                <mat-option [value]="season">{{season}}</mat-option>
            }       
        </mat-select>
    </mat-form-field>

    <!-- Rival filter -->
    <mat-form-field>
        <mat-label>Filter by rival</mat-label>
        <mat-select formControlName="rival">
            @for (rival of rivals; track rival) {
                <mat-option [value]="rival">{{rival}}</mat-option>
            }       
        </mat-select>
    </mat-form-field>

    <!-- Player filter -->
    <mat-form-field aria-label="Players selection">
        <mat-label>Filter by player</mat-label>
        <mat-chip-grid #playersGrid aria-label="Players selection">
            @for (player of this.service.playersSelected; track player) {
                <mat-chip-row (removed)="removePlayer(player)">
                    {{player.name}}
                    <button matChipRemove [attr.aria-label]="'remove ' + player">
                      <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            }
        </mat-chip-grid>
        
        <input #playerInput type="text" placeholder="Select player" matInput [formControl]="this.service.playersForm"
            [matAutocomplete]="autoPlayer" [matChipInputFor]="playersGrid" (input)="filterPlayers()" (focus)="filterPlayers()" (matChipInputTokenEnd)="addPlayer($event)">
        <mat-autocomplete requireSelection #autoPlayer="matAutocomplete" (optionSelected)="selectPlayer($event)">
          @for (player of playersFiltered; track player) {
            <mat-option [value]="player">{{player.name}}</mat-option>
        }
        </mat-autocomplete>
    </mat-form-field>

    <button mat-flat-button type="submit" color="primary">Submit</button>
</form>